import React, {useRef, useState} from 'react';
import {UseLoader} from "../../../../hooks/useLoader";
import {UsePermissions} from "../../../../hooks/usePermissions";
import NumberFormat from "react-number-format";
import {confirmDialog} from "primereact/confirmdialog";
import {crearLiquidacion} from "../../../../api/liquidacion.service";
import {convertirModena} from "../../../../shared/utils/utils";
import {ColumnGroup} from "primereact/columngroup";
import {Row} from "primereact/row";
import {Column} from "primereact/column";
import {Toast} from "primereact/toast";
import {DataTable} from "primereact/datatable";

const TableEditEventoGeneral = ({liquidacion, factura, reload}) => {
    const toast = useRef(null);
    const [handleLoad] = UseLoader();
    const [permisos] = UsePermissions()
    const [totalSuma, setTotalSuma] = useState(0);

    const textEditorGeneral = (options) => {
        return <NumberFormat
            id="valor"
            thousandsGroupStyle="thousand"
            value={options.value}
            prefix="$"
            displayType="input"
            type="text"
            decimalSeparator="."
            className="form-input-small "
            thousandSeparator={true}
            allowNegative={true}
            onValueChange={(e) => options.editorCallback(e.value)}
        />
    }

    const OnSave = () => {
        if (Math.round(totalSuma) > Math.round(parseFloat(factura.valor_factura)) || Math.round(totalSuma) < Math.round(parseFloat(factura.valor_factura))) {
            toast.current?.show({
                severity: 'warn',
                summary: 'Alerta',
                detail: `La suma total de los valores debe ser al e valor facturado`,
                life: 3000
            });
            return;
        }

        confirmDialog({
            message: '¿Estas seguro?',
            header: 'Confirmación',
            acceptLabel: "Si",
            rejectLabel: "No",
            accept: async () => {
                handleLoad(true);
                const payload = {
                    tipo: "E",
                    datos: liquidacion
                }
                const response = await crearLiquidacion(payload);

                handleLoad(false)

                if (response.estado !== 200) {
                    toast.current?.show({severity: 'error', summary: 'Alerta', detail: response.mensaje, life: 3000});
                    return;
                }

                toast.current?.show({severity: 'success', summary: 'Exito', detail: response.mensaje, life: 3000});
                reload()
            }
        });
    }

    const valorNetoDistribucion = (porcentaje) => {

        for (let liq of liquidacion) {
             const totalDescuento = liq.valor * porcentaje;
            liq.valor_neto = isNaN(liq.valor -  totalDescuento) ? 0 : liq.valor -  totalDescuento;
        }
    }


    const valorBrutoTotal = () => {
        let total = 0;
        const  porceIndividual = factura.porcentaje / 100;
        for (let liq of liquidacion) {
            total += liq.valor === '' ? 0 : parseFloat(liq.valor);

        }
        valorNetoDistribucion(porceIndividual)

        setTotalSuma(total)
        return convertirModena(total);
    }

    const valorNetoTotal = () => {
        let total = 0;
        for (let liq of liquidacion) {
            total += liq.valor_neto === '' ? 0 : parseFloat(liq.valor_neto);
        }
        return convertirModena(total);
    }

    let footerGroup =
        <ColumnGroup>
            <Row>
                <Column footer="" colSpan={0} footerStyle={{marginLefth: '10px'}}/>
                <Column footer={valorBrutoTotal}/>
                <Column footer="" colSpan={0} footerStyle={{marginLefth: '10px'}}/>
                <Column footer={valorNetoTotal}/>

            </Row>
            <Row>


            </Row>
        </ColumnGroup>;


    const header = (
        <div className="flex align-items-center justify-between">
            <div>
                <button
                    className="primary-color-btn btn"
                    type="button"
                    disabled={(!permisos.adicionar)}
                    onClick={OnSave}
                >
                    <i className="fa fa-save"/>
                </button>
            </div>
        </div>
    );


    const onCellEditCompleteGeneral = (e) => {
        let {rowData, newValue, field, originalEvent: event} = e;
        if (newValue.trim().length > 0) {
            rowData[field] = newValue;
        } else {
            event.preventDefault();
        }
    }

    const footer = (
        <div className="flex align-items-center  ">
            <p className={totalSuma > parseInt(factura.valor_factura) ? 'p-2  text-sm text-red-600' : 'p-2 text-sm text-teal-600 '}>
                Valor  factura: {convertirModena(factura.valor_factura)}</p>

        </div>
    );

    const valueBodyTemplateBruto = (rowData) => {
        return convertirModena(rowData.valor);
    }

    return (
        <>
            <Toast ref={toast}/>
            <DataTable
                showGridlines
                value={liquidacion}
                size="small"
                editMode="cell"
                dataKey="id"
                header={header}
                footer={footer}
                scrollable scrollHeight="400px"
                footerColumnGroup={footerGroup}
                responsiveLayout="scroll">
                <Column filter sortable field="afiliados" header="Afiliados" style={{width: '10%'}}></Column>
                <Column field="valor" header="Valor bruto"
                        onCellEditComplete={onCellEditCompleteGeneral}
                        editor={(options) => textEditorGeneral(options)}
                         style={{width: '10%'}}></Column>
                <Column field="valor" body={valueBodyTemplateBruto} header="Valor bruto $" style={{width: '10%'}}></Column>
                <Column field="valor_neto" header="Valor neto" style={{width: '10%'}}></Column>


            </DataTable>
        </>
    );
};

export default TableEditEventoGeneral;